/* eslint-disable */

import {
  AdvancedQueryColumnFilter,
  AdvancedQueryColumnSort,
  ViewTermsOfService,
  TermsOfServiceDetailDto,
  EmptyResponse,
  Error,
  CreateNewTermsOfServiceRequest,
  CreateTermsOfServiceRequest,
  UpdateTermsOfServiceRequest,
  TermsOfServiceGetDto,
  IList,
  List,
  Response,
  AdvancedQueryPage,
  IRequestOptions,
  IRequestConfig,
  getConfigs,
  axios,
  basePath
} from './index.defs';

export class TermsOfServiceService {
  /** Generate by swagger-axios-codegen */
  // @ts-nocheck
  /* eslint-disable */

  /**
   *
   */
  static getAllStandardView(
    params: {
      /**  */
      page?: number;
      /**  */
      pageSize?: number;
      /**  */
      searchFieldNames?: string[];
      /**  */
      searchSearchText?: string;
      /**  */
      searchExactMatch?: boolean;
      /**  */
      filtered?: AdvancedQueryColumnFilter[];
      /**  */
      sorted?: AdvancedQueryColumnSort[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<AdvancedQueryPage<ViewTermsOfService>>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/terms-of-service';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Page: params['page'],
        PageSize: params['pageSize'],
        'Search.FieldNames': params['searchFieldNames'],
        'Search.SearchText': params['searchSearchText'],
        'Search.ExactMatch': params['searchExactMatch'],
        Filtered: params['filtered'],
        Sorted: params['sorted']
      };
      let data = null as any;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllViewByBusinessUnit(
    params: {
      /**  */
      page?: number;
      /**  */
      pageSize?: number;
      /**  */
      searchFieldNames?: string[];
      /**  */
      searchSearchText?: string;
      /**  */
      searchExactMatch?: boolean;
      /**  */
      filtered?: AdvancedQueryColumnFilter[];
      /**  */
      sorted?: AdvancedQueryColumnSort[];
      /**  */
      businessUnitId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<AdvancedQueryPage<ViewTermsOfService>>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/terms-of-service/business-unit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Page: params['page'],
        PageSize: params['pageSize'],
        'Search.FieldNames': params['searchFieldNames'],
        'Search.SearchText': params['searchSearchText'],
        'Search.ExactMatch': params['searchExactMatch'],
        Filtered: params['filtered'],
        Sorted: params['sorted'],
        businessUnitId: params['businessUnitId']
      };
      let data = null as any;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getByIdentifier(
    params: {
      /**  */
      identifier: string;
      /**  */
      page?: number;
      /**  */
      pageSize?: number;
      /**  */
      searchFieldNames?: string[];
      /**  */
      searchSearchText?: string;
      /**  */
      searchExactMatch?: boolean;
      /**  */
      filtered?: AdvancedQueryColumnFilter[];
      /**  */
      sorted?: AdvancedQueryColumnSort[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<AdvancedQueryPage<TermsOfServiceDetailDto>>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/terms-of-service/view/{identifier}';
      url = url.replace('{identifier}', params['identifier'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Page: params['page'],
        PageSize: params['pageSize'],
        'Search.FieldNames': params['searchFieldNames'],
        'Search.SearchText': params['searchSearchText'],
        'Search.ExactMatch': params['searchExactMatch'],
        Filtered: params['filtered'],
        Sorted: params['sorted']
      };
      let data = null as any;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getByIdentifierAndBusinessUnit(
    params: {
      /**  */
      identifier: string;
      /**  */
      businessUnitId?: number;
      /**  */
      page?: number;
      /**  */
      pageSize?: number;
      /**  */
      searchFieldNames?: string[];
      /**  */
      searchSearchText?: string;
      /**  */
      searchExactMatch?: boolean;
      /**  */
      filtered?: AdvancedQueryColumnFilter[];
      /**  */
      sorted?: AdvancedQueryColumnSort[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<AdvancedQueryPage<TermsOfServiceDetailDto>>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/business-units/terms-of-service/view/{identifier}';
      url = url.replace('{identifier}', params['identifier'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        businessUnitId: params['businessUnitId'],
        Page: params['page'],
        PageSize: params['pageSize'],
        'Search.FieldNames': params['searchFieldNames'],
        'Search.SearchText': params['searchSearchText'],
        'Search.ExactMatch': params['searchExactMatch'],
        Filtered: params['filtered'],
        Sorted: params['sorted']
      };
      let data = null as any;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getNewestPublishedTermsByIdentifier(
    params: {
      /**  */
      identifier: string;
      /**  */
      businessUnitId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<TermsOfServiceDetailDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/terms-of-service/{identifier}/published';
      url = url.replace('{identifier}', params['identifier'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { businessUnitId: params['businessUnitId'] };
      let data = null as any;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getById(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<TermsOfServiceDetailDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/terms-of-service/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null as any;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<EmptyResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/terms-of-service/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null as any;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static createNew(
    params: {
      /**  */
      body?: CreateNewTermsOfServiceRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<TermsOfServiceDetailDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/terms-of-service/create/new';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['body'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static createFromExisting(
    params: {
      /**  */
      body?: CreateTermsOfServiceRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<TermsOfServiceDetailDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/terms-of-service/create/from-existing';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['body'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /**  */
      id: number;
      /**  */
      body?: UpdateTermsOfServiceRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<TermsOfServiceGetDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/terms-of-service/update/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['body'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static publish(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<TermsOfServiceDetailDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/terms-of-service/publish/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = null as any;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
